<template>
    <div class="main-data-digitaltools">
        <div class="form-entry-list">
            <div class="form-entry-item" v-for="(item,index) in dataList" :key="index"  @click="jumpForm(item)">
                <span class="name">{{item.label}}</span>
            </div>
        </div>
        <el-dialog
            title="我的流程"
            width="80%"
            top="2vh"
            append-to-body
            :visible.sync="isShowMyProcess"
            >
            <DigitalToolProcess
                :key="loadTimer"
                :tableHeight="500"
                ref="digitalToolProcess"
                />
        </el-dialog>
        <el-dialog
            title="我的任务"
            width="80%"
            top="2vh"
            append-to-body
            :visible.sync="isShowMyTask"
            >
            <DigitalToolTask
                :key="loadTimer"
                :tableHeight="500"
                ref="digitalToolTask"
                />
        </el-dialog>
        <el-dialog
            :title="approvalTitle"
            width="80%"
            top="0vh"
            append-to-body
            class="approval-pop-dialog"
            :visible.sync="isShowApprovalPop"
            :fullscreen=true
            >
            <ApprovalPop
                    :key="loadTimer"
                    ref="approvalPop"
                    :instances="{id:approvalInstanceId,formObj: {}}"
                    :isInstance="false"
                    :approvalTemplateObj="templateInfo"
                    :busiProcessInstanceId="busiProcessInstanceId"
                    :busiProcessInstanceName="busiProcessInstanceName"
                    :busiTaskInstanceId="busiTaskInstanceId"
                    :belongProcessFlag="belongProcessFlag"
                    :formDataFromBusiness="formInfo"
                    :taskParam="taskParam"
                    :processModelFormsObj="processModelFormsObj"/>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleSaveDraft" type="success">保存草稿</el-button>
                <el-button @click="handleApply" :loading="startApprovalloading" type="primary">发起审批</el-button>
                <el-button @click="isShowApprovalPop=false"  type="info">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { isEmpty } from 'lodash';
    import DigitalToolProcess from '@/components/DigitalTool/DigitalToolProcess';
    import DigitalToolTask from '@/components/DigitalTool/DigitalToolTask';
    export default{
        components: {
            DigitalToolProcess,
            DigitalToolTask
        },
        props: {
            dataList: {
                type: Array
            }
        },
        data () {
            return {
                loadTimer: '',
                isShowMyProcess: false,
                isShowMyTask: false,
                isShowApprovalPop: false,
                approvalTitle: '',
                busiProcessInstanceId: '',
                busiProcessInstanceName: '',
                busiTaskInstanceId: '',
                belongProcessFlag: 0,
                processModelFormsObj: [],
                formInfo: {},
                taskParam: {},
                templateInfo: {
                    id: '',
                    templateName: '',
                    busiType: '',
                    busiTypeName: '',
                    remarks: '',
                    selectedUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    templateState: null,
                    forms: [],
                    users: [],
                    approvalList: [[]],
                    dataOperate: {
                        dataSource: 2,
                        forms: []
                    },
                    orderMode: 0,
                    rejectMode: 0,
                    sendSms: 0,
                    clearApprovalUsers: 0,
                    durTime: 0,
                    warnDate: '',
                    selectedCopyUser: {
                        selectedUserIds: '',
                        selectedUserNames: ''
                    },
                    approvalMethod: 1, // 审批方法，1:普通审批，2:审批流节点或签审批
                    showAllMyApprovals: true
                },
                approvalInstanceId: '',
                startApprovalloading: false
            };
        },
        created () {
        },
        methods: {
            jumpForm (obj) {
                switch (obj.key) {
                case '1':
                    this.showMyprocess();
                    break;
                case '2':
                    this.showMyTask();
                    break;
                case '3':
                    // this.sendApprove();
                    break;
                case '4':
                    // this.sendApprove();
                    break;
                case '5':
                    // this.sendApprove();
                    break;
                }
            },
            showMyprocess () {
                this.loadTimer = new Date().getTime();
                this.isShowMyProcess = true;
            },
            showMyTask () {
                this.loadTimer = new Date().getTime();
                this.isShowMyTask = true;
            },
            sendApprove (obj) {
                this.approvalTitle = '发起【' + obj.templateName + '】审批申请';
                this.templateInfo = obj;
                // this.templateInfo.templateName = '';
                this.templateInfo.remarks = '';
                this.templateInfo.selectedUser = {};
                if (!isEmpty(obj.selectedUserIds)) {
                    if (obj.clearApprovalUsers) {
                        this.templateInfo.selectedUser.selectedUserIds = '';
                        this.templateInfo.selectedUser.selectedUserNames = '';
                        this.templateInfo.selectedUserIds = '';
                        this.templateInfo.selectedUserNames = '';
                    } else {
                        this.templateInfo.selectedUser.selectedUserIds = obj.selectedUserIds;
                        this.templateInfo.selectedUser.selectedUserNames = obj.selectedUserNames;
                    }
                } else { // 解决ApprovalPop页面selectedUser.selectedUserNames不能为空的rule提示异常
                    this.templateInfo.selectedUser.selectedUserIds = '';
                    this.templateInfo.selectedUser.selectedUserNames = '';
                }
                this.loadTimer = new Date().getTime();
                this.approvalInstanceId = this.generateUUID();
                setTimeout(() => { // 默认回显值
                    this.$refs.approvalPop._initPage();
                }, 0);
                this.isShowApprovalPop = true;
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            async handleSaveDraft () {
                // opType 操作模式：1 保存草稿 2发起审批
                let isToApproval = this.$refs.approvalPop.isToApproval();
                if (!isToApproval) {
                    return;
                }
                let isValid = await this.$refs.approvalPop.handelSaveForms(1);
                // console.log(isValid);
                if (!isValid) {
                    this.isShowApprovalPop = false;
                    sessionStorage.setItem('isShowApprovalDraft', true);
                    if (this.belongProcessFlag === 0) {
                        this.navMyApprovalApplied();
                    } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                        this.$emit('closeApprovalTemplate', {index: '3'});
                    }
                }
            },
            async handleApply () {
                setTimeout(() => { // 默认回显值
                    let isToApproval = this.$refs.approvalPop.isToApproval();
                    if (!isToApproval) {
                        return;
                    }
                    this.hasApplyUser = this.$refs.approvalPop.hasApplyUser();
                    if (this.hasApplyUser) {
                        this.$confirm(`审批人中含有申请人,您确定要发起审批吗？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (res) => {
                            this.startApprovalloading = true;
                            let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                            if (!isValid) {
                                this.isShowApprovalPop = false;
                                // console.log("============="+this.belongProcessFlag);
                                if (this.belongProcessFlag === 0) {
                                    this.navMyApprovalApplied();
                                } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                                    this.$emit('closeApprovalTemplate', {index: '0'});
                                }
                            }
                            this.startApprovalloading = false;
                        }).catch(() => {
                        });
                    } else {
                        // opType 操作模式：1 保存草稿 2发起审批
                        this.$confirm(`您确定要发起审批吗？`, '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(async (res) => {
                            this.startApprovalloading = true;
                            let isValid = await this.$refs.approvalPop.handelSaveForms(2);
                            if (!isValid) {
                                this.isShowApprovalPop = false;
                                // console.log("============="+this.belongProcessFlag);
                                if (this.belongProcessFlag === 0) {
                                    this.navMyApprovalApplied();
                                } else if (this.belongProcessFlag === 1 || this.belongProcessFlag === 2) {
                                    this.$emit('closeApprovalTemplate', {index: '0'});
                                }
                            }
                            this.startApprovalloading = false;
                        }).catch(() => {});
                    }
                }, 100);
            }
        }
    };
</script>

<style lang="less">
    .main-data-digitaltools{
        .form-entry-list{
            display: flex;
            flex-wrap: wrap;
            .form-entry-item{
                display: inline-block;
                width: auto;
                height: 60px;
                margin-left: 10px;
                margin-top: 10px;
                cursor: pointer;
                background: #FFFFFF;
                text-align: center;
                line-height: 60px;
                padding: 0px 16px 0px 16px;
                border-radius: 6px;
                border: 1px solid #e8edf1;
            }
            .form-entry-item:hover{
                border: 1px solid #00bcd4;
            }
        }
    }
    .model-data-showpage{

    }

</style>



// WEBPACK FOOTER //
// src/components/DataWarehousing/DigitalToolsPreview.vue